import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Template/TemplateKRA.html'
})

export class TemplateKRAComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public showLoader = false;
    public EmployeeList:any = [];
    public PeriodList:any = [];
    public ReviewTemplateDetails:any = {PeriodId:null,EmployeeId:null};
    public reviewTemplateId: any = null;
    public ReviewKRATemplates: any = [];
    public KRATotalWeightage: any = 0;
    public ReviewKPITemplates: any = [];
    public KPITotalWeightage: any = 0;
    public ReviewKPITemplateList: any = [];
    public ReviewKPITemplateKRA:any = {};
    active = true;
    public saveAsTemplate:any = false;
    public isLock:any = false;
    public ReviewTemplateList: any = [];
    deleteCountKRA:any  = 0;
    deleteCountKPI:any  = 0;
    public isCopy:any; 
    public Templateshow:any;
    public DeleteKRAList :any=[];
    public DeleteKPIList :any=[];
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService ,private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));

         this.route
            .params
            .subscribe(
            data => {
                this.reviewTemplateId = data["TemplateID"];
               // this.isCommercialEdit = data["Com"];
            }
            
            );
 
        //this.reviewTemplateId = JSON.parse(localStorage.getItem("ReviewTemplateId"));
    }

    ngOnInit() {
       // this.getEmployeeList();
        this.getPeriodList();
         this.getReviewTemplateList();
        this.ReviewTemplateDetails.ReviewTemplateId = this.reviewTemplateId;
        if(this.reviewTemplateId == 0){
            this.ReviewTemplateDetails.CreatedBy = this.userDetail.SiteUserId;
            this.Templateshow=1;
            this.addKRAToList()
            this.addKRAToList()
            this.addKRAToList()
           
        }
        else{
            this.getReviewTemplate();
            this.Templateshow=0;
        }

            this.isCopy=false;
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
    }

    public getEmployeeList() {
        this.showLoader = true;
        this._httpService.ajaxPost("Users/GetUsersList",
            {
                "IsActive": this.constants.enumUserStatus["Active"],
                "Role": null,
                "Site": null,
                "Team":this.userDetail.TeamID,
                "UserId":this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.EmployeeList = data["Users"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

    public getPeriodList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetPeriod', null).subscribe(
            data => {
                this.PeriodList = data["PeriodList"];
                this.PeriodList = this.PeriodList.filter( x => x.IsActive === true);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
    public getReviewTemplateForCopy(){
       
       this.isCopy=true;

       if(this.reviewTemplateId =="null")
       {this.ReviewTemplateDetails.CommentObjective ="";
       this.ReviewTemplateDetails.CreatedBy =this.userDetail.UserId;
       this.ReviewTemplateDetails.TemplateTitle ="";
       this.ReviewTemplateDetails.ReviewTemplateId =null;
       this.ReviewTemplateDetails.PeriodId =null;
       this.ReviewKRATemplates = [];
       this.ReviewKPITemplates = [];
       this.KPITotalWeightage = 0;
     }
      else
        this.getReviewTemplate();
   
                   
        
               


    }
    public getReviewTemplate() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewTemplate/GetReviewTemplate', {"TemplateId":this.reviewTemplateId,"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.ReviewTemplateDetails = data["ReviewTemplates"][0];
                this.ReviewTemplateDetails.EmployeeId = null;
                this.ReviewKRATemplates = data["ReviewKRATemplates"];
                this.ReviewKPITemplates = data["ReviewKPITemplates"];
                this.setupKRAActions();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public setupKRAActions(){
        this.KRATotalWeightage = 0;
        this.KPITotalWeightage = 0;
        var count = 1;
        this.ReviewKRATemplates.forEach(element => {
            var isKPI = false;
            var count1 = 1;
            this.ReviewKPITemplates.forEach(element1 => {
                if(element1.KRATemplateId == element.KRATemplateId){
                    isKPI = true;
                    element1.KRASequenceId = count;
                }
                element1.SequenceId = count1;
                count1 = count1+1;
            });
            element.IsEditKPI = isKPI;
            element.SequenceId = count;
            count = count+1;
            this.KRATotalWeightage = this.KRATotalWeightage + parseInt(element.Weightage);
        });

if(this.isCopy==true){
               this.ReviewTemplateDetails.ReviewTemplateId=0;
                this.ReviewTemplateDetails.CreatedBy = this.userDetail.SiteUserId;;
                this.ReviewTemplateDetails.PeriodId = null;
     
      this.ReviewKRATemplates.forEach(element => {
         element.KRATemplateId =0;
         element.ReviewTemplateId =0;
            this.ReviewKPITemplates.forEach(element1 => {
              element1.KPITemplateId= 0;
              element1.KRATemplateId =0;

            });
         
        });
}
this.showKPIList()
    }
  public getReviewTemplateList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetReviewTemplate', {"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.ReviewTemplateList = data["ReviewTemplateList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    showKPIList(){
       
        this.ReviewKRATemplates.forEach(item => {
            item.KPITotalWeightage = 0;
            item.ReviewKPITemplateList=JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m1 => m1.KRASequenceId == item.SequenceId)))
            this.ReviewKPITemplates.filter(m1 => m1.KRASequenceId == item.SequenceId).forEach(c => item.KPITotalWeightage += c.Weightage);
        });
       
         if(this.deleteCountKPI == 0){
         this.deleteCountKPI = this.ReviewKPITemplates.length;
         }
     }
 
    // showKPIList(KRASequenceId){
    //    // this.ReviewKPITemplateKRA = JSON.parse(JSON.stringify(this.ReviewKRATemplates.filter(m => m.SequenceId == KRASequenceId)[0]));
    //     //this.ReviewKPITemplateList = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m => m.KRASequenceId == KRASequenceId)));
    //     this.ReviewKRATemplates.filter(m => m.SequenceId == KRASequenceId)[0].ReviewKPITemplateList=JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m1 => m1.KRASequenceId == KRASequenceId)));
       
    //     //this.ReviewKPITemplateList.splice(KRASequenceId,0,(JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m => m.KRASequenceId == KRASequenceId)))));
    //     this.KPITotalWeightage = 0;
        
    //     var tempTemplate =this.ReviewKRATemplates.filter(m => m.SequenceId == KRASequenceId)[0];
    //     tempTemplate.KPITotalWeightage = 0;
    //    //ReviewKPITemplateList.forEach(element => {
    //     tempTemplate.ReviewKPITemplateList.forEach(element => {
    //        // this.KPITotalWeightage = this.KPITotalWeightage + parseInt(element.Weightage);
    //        tempTemplate.KPITotalWeightage = tempTemplate.KPITotalWeightage + parseInt(element.Weightage);
    //     });
    
    //     if(this.deleteCountKPI == 0){
    //     this.deleteCountKPI = this.ReviewKPITemplates.length;
    //     }
    // }

    public addKRAToList(){
        var KRAListItem = {
            KRATemplateId : 0,
            KRADescription : "",
            Weightage : 0,
            ReviewTemplateId : this.ReviewTemplateDetails.ReviewTemplateId,
            SequenceId : this.deleteCountKRA + this.ReviewKRATemplates.length + 1 ,
            IsEditKPI : false  ,
            ReviewKPITemplateList:[], 
            KPITotalWeightage:0         
        };
        this.ReviewKRATemplates.push(KRAListItem);
        this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates));
    }

    public deleteKRAFromList(item){
        this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m => m.KRASequenceId != item.SequenceId)));
        this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates.filter(m => m.SequenceId != item.SequenceId)));
        this.deleteCountKRA = this.deleteCountKRA + 1;
        this.DeleteKRAList.push(item.KRATemplateId);
        this.calculateTotalKRAWeightage()
    }

    public calculateTotalKRAWeightage(){
        this.KRATotalWeightage = 0;
        this.ReviewKRATemplates.forEach(element => {
            this.KRATotalWeightage = this.KRATotalWeightage + parseInt(element.Weightage);
        });
    }

    public addKPIToList(template){
        var KPIListItem = {
            KPITemplateId: 0,
            KPIDescription: "",
            Weightage: 0,
            KRASequenceId: template.SequenceId,
            KRATemplateId: template.KRATemplateId,
            SequenceId: this.deleteCountKPI + template.ReviewKPITemplateList.length + 1
            // KRASequenceId: this.ReviewKPITemplateKRA.SequenceId,
            // KRATemplateId: this.ReviewKPITemplateKRA.KRATemplateId,
            // SequenceId: this.deleteCountKPI + this.ReviewKPITemplateList.length + 1
        };
        template.ReviewKPITemplateList.push(KPIListItem);
        template.ReviewKPITemplateList=JSON.parse(JSON.stringify(template.ReviewKPITemplateList));
        //this.ReviewKPITemplateList.push(KPIListItem);
        //this.ReviewKPITemplateList = JSON.parse(JSON.stringify(this.ReviewKPITemplateList));
    }

    public deleteKPIFromList(item){
        var tempTEmplate =this.ReviewKRATemplates.filter(m => m.SequenceId == item.KRASequenceId)[0].ReviewKPITemplateList;
       this.ReviewKRATemplates.filter(m => m.SequenceId == item.KRASequenceId)[0].ReviewKPITemplateList= JSON.parse(JSON.stringify(tempTEmplate.filter(m1 => m1.SequenceId != item.SequenceId)));
       // this.ReviewKPITemplateList = JSON.parse(JSON.stringify(this.ReviewKPITemplateList.filter(m => m.SequenceId != item.SequenceId)));
        this.deleteCountKPI = this.deleteCountKPI + 1;
        this.DeleteKPIList.push(item.KPITemplateId);
        this.calculateTotalKPIWeightage(item)
    }

    public calculateTotalKPIWeightage(template){
        var tempTemplate =this.ReviewKRATemplates;
       
 if(template != null){
             tempTemplate =this.ReviewKRATemplates.filter(m => m.SequenceId == template.KRASequenceId)[0];
             tempTemplate.KPITotalWeightage = 0;
             tempTemplate.ReviewKPITemplateList.forEach(element => {
              tempTemplate.KPITotalWeightage = tempTemplate.KPITotalWeightage + parseInt(element.Weightage);
                 });
            }


       //ReviewKPITemplateList.forEach(element => {
       
       // this.KPITotalWeightage = 0;
        //this.ReviewKPITemplateList.forEach(element => {
            //this.KPITotalWeightage = this.KPITotalWeightage + parseInt(element.Weightage);
       // });
    }

    public addUpdateReviewEmployeeKPI(){
        var check =1;
        if(this.ReviewKRATemplates.filter(m => (m.KPITotalWeightage != 100 && m.ReviewKPITemplateList.length>0)).length==0){
            // this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m =>
            //  m.KRATemplateId != this.ReviewKPITemplateKRA.KRATemplateId)));
            this.ReviewKPITemplates=[];
        
            this.ReviewKRATemplates.forEach(element => {
                element.ReviewKPITemplateList.forEach(item => {
                this.ReviewKPITemplates.push(item);
               
               });

               if(element.ReviewKPITemplateList.length!=0)
                      element.IsEditKPI = true;
            });
            
            this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates))
            this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates));
            check=0;
    }
    else{
        this._sharedService.ShowMessage("error|" + "Total KPI weightage should be 100");
    }
    if(check==0){
        this.addUpdateReviewTemplate()
    }
    }

    // public addUpdateReviewEmployeeKPI(){
    //     if(this.validateReviewKPIDetails()){
    //         // this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m =>
    //         //     m.KRATemplateId != this.ReviewKPITemplateKRA.KRATemplateId)));
    //         this.ReviewKRATemplates
    //         this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m =>
    //             m.SequenceId != this.ReviewKPITemplateKRA.SequenceId)));
    //         this.ReviewKPITemplateList.forEach(element => {
    //             this.ReviewKPITemplates.push(element);
    //             this.ReviewKRATemplates.forEach(kra => {
    //                 if(kra.SequenceId == element.KRASequenceId){
    //                     kra.IsEditKPI = true;
    //                 }
    //             });
    //         });
    //         $('#addEditKPI').modal('hide');
    //     }
    // }

    validateReviewKPIDetails(){
        var mandatory = "";
        var invalid = "";
        var functional = "";

        if(this.ReviewKPITemplates.length != 0)
        {
           
            this.ReviewKPITemplates.forEach(element => {
                if(element.KPIDescription == "" || element.KPIDescription == null)
                {
                    mandatory = mandatory + "<br>KPI Description";
                }
                if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
                {
                    mandatory = mandatory + "<br>Weightage";
                }
                if( isNaN(element.Weightage))
                    {
                        mandatory = mandatory + "<br>KPI Weightage should be number";
                    }
            });
        }
        
        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;

    }

    public addUpdateReviewEmployee(){
         
        console.log("ReviewEmployeeDetails");
        console.log(this.ReviewTemplateDetails);
        // CommentObjective: "New Objectives"
        // CreatedBy: 1
        // EmployeeId: "153"
        // PeriodId: 1
        // ReviewTemplateId: 1
        // TemplateTitle: "FY12019"
        var ReviewEmployeeDetails = {
            EmployeeReviewId : 0,
            EmployeeId : null,
            ReviewerId : null,
            PeriodId : this.ReviewTemplateDetails.PeriodId,
            CommentObjective : this.ReviewTemplateDetails.CommentObjective,
            CreatedBy : this.ReviewTemplateDetails.CreatedBy,
            IsLock : this.isLock
        }

        ReviewEmployeeDetails.EmployeeId = parseInt(this.ReviewTemplateDetails.EmployeeId);
        ReviewEmployeeDetails.ReviewerId = this.EmployeeList.filter(m => m.SiteUser_Id == ReviewEmployeeDetails.EmployeeId)[0].Reviewed_By;

        console.log("ReviewEmployeeKRADetails");
        console.log(this.ReviewKRATemplates);
        // IsEditKPI: true
        // KRADescription: "Sales of 50000 aed"
        // KRATemplateId: 1
        // ReviewTemplateId: 1
        // SequenceId: 1
        // Weightage: 50
        var ReviewKRADetails = [];
        this.ReviewKRATemplates.forEach(element => {
            var KRAItem = {
                KRAId : element.KRATemplateId,
                KRADescription : element.KRADescription,
                Weightage : element.Weightage,
                EmployeeReviewId : null,
                IsEditKPI : element.IsEditKPI,
                SequenceId : element.SequenceId
            };
            ReviewKRADetails.push(KRAItem);
        });

        console.log("ReviewEmployeeKPIDetails");
        console.log(this.ReviewKPITemplates);
        // KPIDescription: "sales with 5% profit"
        // KPITemplateId: 3
        // KRASequenceId: 1
        // KRATemplateId: 1
        // SequenceId: 1
        // Weightage: 50
        var ReviewKPIDetails = [];
        this.ReviewKPITemplates.forEach(element => {
            var KPIItem = {
                KPIId : element.KPITemplateId,
                KPIDescription : element.KPIDescription,
                Weightage : element.Weightage,
                KRAId : element.KRATemplateId,
                KRASequenceId : element.KRASequenceId,
                SequenceId : element.SequenceId
            };
            ReviewKPIDetails.push(KPIItem);
        });

        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/AddUpdateReviewEmployeeDetails', 
        {"ReviewEmployeeDetails":ReviewEmployeeDetails,
        "ReviewKRADetails":ReviewKRADetails,
        "ReviewKPIDetails":ReviewKPIDetails}).subscribe(
            data => {
                
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        
    }

    validateReviewDetails(){
        var mandatory = "";
        var invalid = "";
        var functional = "";

      

        if (this.ReviewTemplateDetails.PeriodId == null || this.ReviewTemplateDetails.PeriodId == "null") {
            mandatory = mandatory + "<br>Period";
        }

        if (this.ReviewTemplateDetails.CommentObjective == null || this.ReviewTemplateDetails.CommentObjective == "") {
            mandatory = mandatory + "<br>Objective Comment";
        }

        if(this.ReviewKRATemplates.length == 0)
        {
            mandatory = mandatory + "<br>KRA List";
        }
        else{
            this.ReviewKRATemplates.forEach(element => {
                if(element.KRADescription == "" || element.KRADescription == null)
                {
                    mandatory = mandatory + "<br>KRA Description";
                }
                if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
                {
                    mandatory = mandatory + "<br>Weightage";
                }
                if( isNaN(element.Weightage))
                    {
                        mandatory = mandatory + "<br>KRA Weightage should be number";
                    }
            });
        }

        //KPI list validated while adding KPI under KRA
        if(this.KRATotalWeightage != 100)
        {
            mandatory = mandatory + "<br>Total KRA weightage should be 100";
        }
       
            if (this.ReviewTemplateDetails.TemplateTitle == null || this.ReviewTemplateDetails.TemplateTitle == "") {
                mandatory = mandatory + "<br>Template Title";
            }
        
        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;
    }
 


    public addUpdateReviewTemplate() {
        if(this.validateReviewKPIDetails()&&this.validateReviewDetails()){
          
                 
                var objReviewTemplateDetails = {
                    ReviewTemplateId: this.ReviewTemplateDetails.ReviewTemplateId,
                    TemplateTitle: this.ReviewTemplateDetails.TemplateTitle,
                    PeriodId: this.ReviewTemplateDetails.PeriodId,
                    CommentObjective: this.ReviewTemplateDetails.CommentObjective,
                    CreatedBy: this.ReviewTemplateDetails.CreatedBy,
                    IsPrivate: this.ReviewTemplateDetails.IsPrivate
                };
                
                if(this.DeleteKRAList.length>0)
                {var deleteKRA =this.DeleteKRAList.toString();
                   deleteKRA=deleteKRA+",";
               }
               if(this.DeleteKPIList.length>0)
               {
                   var deleteKPI =this.DeleteKPIList.toString();
                deleteKPI=deleteKPI+",";
              }

                this.showLoader = true;
                this._httpService.ajaxPost('ReviewTemplate/AddUpdateReviewTemplate', {"ReviewTemplateDetails":objReviewTemplateDetails,
                "ReviewTemplateKRADetails":this.ReviewKRATemplates,"ReviewTemplateKPIDetails":this.ReviewKPITemplates,"deleteKPI":deleteKPI,"deleteKRA":deleteKRA,"UserId":this.userDetail.SiteUserId}).subscribe(
                    data => {
                        //this.addUpdateReviewEmployee();
                         this._sharedService.ShowMessage("success|Data Updated Successfully");
                          this._route.navigateByUrl("/Template");
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
           
        }
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Template/TemplateKRA.component.ts
 **/